<template>
  <b-form-group label="CEP:">
    <b-form-input
      type="text"
      v-model="valor"
      placeholder="CEP"
      v-mask="'#####-###'"
      :state="valid"
      @blur="validar"
    ></b-form-input>
    <b-form-invalid-feedback>
      O CEP informado não é válido.
    </b-form-invalid-feedback>
  </b-form-group>
</template>

<style lang="scss" scoped></style>

<script>
import { mapActions } from "vuex";

export default {
  name: "InputCEP",
  data() {
    return {
      valid: null
    };
  },
  computed: {
    valor: {
      get: function() {
        return this.value;
      },
      set: function(newValue) {
        this.$emit("input", newValue);
      }
    }
  },
  props: ["value"],
  methods: {
    ...mapActions(["getCEP"]),
    validar(buscarCEP = true) {
      let cep = this.valor.replace(/[^\d]+/g, "");

      if (cep.length == 8) {
        this.valid = true;
        if(buscarCEP) {
          this.buscaCEP();
        }
      } else {
        this.valid = false;
      }
    },
    async buscaCEP() {
      let cep = await this.getCEP(this.valor.replace(/[^\d]+/g, ""));
      this.$emit("buscacep", cep);
    }
  }
};
</script>
